import * as yup from 'yup';

const businessAddressFields = {
  businessAddress: yup.string().required('Business address is required').trim(),
  country: yup.string().required('Country is required'),
  customCountry: yup.string().when('country', {
    is: 'others',
    then: (schema) => schema.required('Please enter your country'),
    otherwise: (schema) => schema.optional(),
  }),
  state: yup.string().required('State is required'),
  customState: yup.string().when('state', {
    is: 'others',
    then: (schema) => schema.required('Please enter your state'),
    otherwise: (schema) => schema.optional(),
  }),
  lga: yup.string().required('LGA/City is required'),
  customLga: yup.string().when('lga', {
    is: 'others',
    then: (schema) => schema.required('Please enter your LGA/City'),
    otherwise: (schema) => schema.optional(),
  }),
};

const businessFields = {
  name: yup
    .string()
    .required('Business name is required')
    .min(2, 'Business name must be at least 2 characters long')
    .max(100, 'Business name must not exceed 100 characters')
    .trim(),

  category: yup
    .string()
    .required('Business category is required')
    .min(2, 'Category must be at least 2 characters long')
    .max(50, 'Category must not exceed 50 characters')
    .trim(),

  description: yup
    .string()
    .required('Business description is required')
    .min(
      100,
      'Business description must be at least 100 characters for AI assistance'
    )
    .max(500, 'Description must not exceed 500 characters')
    .trim(),

  ...businessAddressFields,

  orderVolume: yup.string().required('Order volume is required'),

  salesChannel: yup.string().required('Sales channel is required').trim(),
};

export const businessCreationSchema = yup.object({
  ...businessFields,
  agreedToTerms: yup
    .boolean()
    .oneOf([true], 'You must accept the terms to continue'),
});

export const businessUpdateSchema = yup.object({
  name: businessFields.name,
  category: businessFields.category,
  description: yup
    .string()
    .trim()
    .optional()
    .test(
      'min-length',
      'Business description must be at least 100 characters for AI assistance',
      (value) => !value || value.length >= 100
    )
    .max(500, 'Description must not exceed 500 characters'),
  businessAddress: yup.string().trim().optional(),
  country: yup.string().optional(),
  customCountry: yup.string().when('country', {
    is: 'others',
    then: (schema) => schema.required('Please enter your country'),
    otherwise: (schema) => schema.optional(),
  }),
  state: yup.string().optional(),
  customState: yup.string().when('state', {
    is: 'others',
    then: (schema) => schema.required('Please enter your state'),
    otherwise: (schema) => schema.optional(),
  }),
  lga: yup.string().optional(),
  customLga: yup.string().when('lga', {
    is: 'others',
    then: (schema) => schema.required('Please enter your LGA/City'),
    otherwise: (schema) => schema.optional(),
  }),
  orderVolume: businessFields.orderVolume,
  salesChannel: businessFields.salesChannel,
});

export type BusinessCreationFormData = yup.InferType<
  typeof businessCreationSchema
>;

export type BusinessUpdateFormData = yup.InferType<typeof businessUpdateSchema>;
